<div class="est-qtr-maintenance-container">
  @if (showLockConfirmModal) {
<gtw-confirmation-modal
   
    [config]="lockConfirmConfig"
    [visible]="showLockConfirmModal"
    (confirmed)="onConfirmLock()"
    (cancelled)="onCancelLock()"
    (closed)="onCancelLock()">
  </gtw-confirmation-modal>
}

  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (showBackdrop && !showFormLoader) {
<div class="text-center" style="padding: 20px;">
    <p>Please select filters and click <strong>Filter</strong> to load quarter maintenance data.</p>
  </div>
}

  @if (!showFormLoader && !showBackdrop) {
<div class="est-qtr-maintenance-panel">
    <div class="est-qtr-maintenance-toolbar">
      <button class="add-row-btn" (click)="addMaintenance()">
        <i class="fa fa-plus-circle"></i> Add row to lock the quarter
      </button>
    </div>

    @for (item of lockedqtrlist; track $index; let i = $index) {
<div class="est-qtr-maintenance-row">
      <button class="delete-row-btn"
              [disabled]="item.locked_status === 1"
              (click)="deleteLockedRow(i)"
              title="Delete row">
        <i class="fa fa-minus-circle"></i>
      </button>

      <div class="field-group">
        <label>Tax Year:</label>
        <input class="form-control input-sm" [value]="item.tax_year" disabled>
      </div>

      <div class="field-group">
        <label>Out Tax Year:</label>
        <input class="form-control input-sm" [value]="item.out_tax_year" disabled>
      </div>

      <div class="field-group">
        <label>Quarter:</label>
        <select class="form-control input-sm"
                [compareWith]="compareQuarterByValue"
                  [ngModel]="item.quarter"
                  (ngModelChange)="item.quarter = $event">
          <option [ngValue]="null">Select</option>
          @for (q of quarterList; track $index) {
<option [ngValue]="q">{{ q.LABEL }}</option>
}
        </select>
      </div>

      <div class="field-group checkbox-group">
        <label>Lock:</label>
        <input type="checkbox"
               [checked]="item.locked_status === 1"
               (change)="onLockToggle($event, item, i)"
               [disabled]="item.locked_status === 1">
      </div>
    </div>
}

    @if (lockedqtrlist.length === 0) {
<div class="text-center" style="padding: 20px;">
      <p>No locked quarters.</p>
    </div>
}
  </div>
}
</div>
